



import JsonViewer from 'vue-json-viewer'
import {Component, Prop, Vue} from "vue-property-decorator";
import AmComponent from "@/valchrom/views/mathservice/dataset/overview/AmComponent.vue";
import OverviewTableComponent from "@/valchrom/views/mathservice/dataset/overview/TableComponent.vue";
import RawData from "@/valchrom/views/mathservice/dataset/overview/RawData.vue";
import OverviewComponent from "@/valchrom/views/mathservice/dataset/overview/OverviewComponent.vue";
import ParametersAccordion from "@/valchrom/views/mathservice/dataset/overview/ParametersAccordion.vue";
import TableComponent from "@/valchrom/views/mathservice/dataset/overview/TableComponent.vue";
import SeriesListComponent from "@/valchrom/views/mathservice/dataset/overview/SeriesListComponent.vue";
import CollapsibleComponent from "@/valchrom/views/mathservice/dataset/overview/CollapsibleComponent.vue";
import TitledComponent from "@/valchrom/views/mathservice/dataset/overview/TitledComponent.vue";
import ComponentList from "@/valchrom/views/mathservice/dataset/overview/ComponentList.vue";
import FailedAMOutput from "@/valchrom/views/mathservice/dataset/overview/FailedAMOutput.vue";
import Loading from "@/valchrom/common/Loading.vue";
import GraphComponent from "@/valchrom/views/mathservice/dataset/overview/GraphComponent.vue";
import ChromatogramComponent from "@/valchrom/views/mathservice/dataset/overview/ChromatogramComponent.vue";
import LodLoqTable from "@/valchrom/views/mathservice/dataset/overview/LodLoqTable.vue";
import Stats from "@/valchrom/views/mathservice/dataset/overview/Stats.vue";
import Series from "@/valchrom/views/mathservice/dataset/overview/Series.vue";

@Component({
    components: {
        AmComponent,
        OverviewTableComponent,
        JsonViewer,
        RawData,
        OverviewComponent,
        ParametersAccordion,
        TableComponent,
        SeriesListComponent,
        CollapsibleComponent,
        TitledComponent,
        ComponentList,
        FailedAMOutput,
        Loading,
        GraphComponent,
        ChromatogramComponent,
        LodLoqTable,
        Stats,
        Series
    },
})
export default class VisualComponent extends Vue {
    @Prop() model: any;

    getComponentForType(){
        if(this.model == null){
            return "Loading"
        }
        if(this.model.type == "Overview"){
            return "OverviewComponent";
        }
        if(this.model.type == "ParamsAccordion"){
            return "ParametersAccordion";
        }
        if(this.model.type == "AMComponent"){
            return "AmComponent";
        }
        if(this.model.type == "VisualTable"){
            return "TableComponent";
        }
        if(this.model.type == "SeriesListCollapsibles"){
            return "SeriesListComponent";
        }
        if(this.model.type == "Collapsible"){
            return "CollapsibleComponent";
        }
        if(this.model.type == "TitledComponent"){
            return "TitledComponent";
        }
        if(this.model.type == "ComponentList"){
            return "ComponentList";
        }
        if(this.model.type == "FailedAMOutput"){
            return "FailedAMOutput";
        }
        if(this.model.type == "LinRegressionGraph" || this.model.type == "ResidualsGraph"){
            return "GraphComponent" ;
        }
        if(this.model.type == "ChromatogramComponent"){
            return "ChromatogramComponent";
        }
        if(this.model.type == "LodLoqTable"){
            return "LodLoqTable";
        }
        if(this.model.type == "Stats"){
            return "Stats";
        }
        if(this.model.type == "Series"){
            return "Series";
        }
        return "RawData"
    }


}
